import type { ReactNode } from 'react';

export const symbol_thermometer_loss: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M590-650q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h260q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H590ZM320-120q-75.53 0-128.76-53.24Q138-226.47 138-302q0-49.1 24-91.55Q186-436 228-462v-286q0-38.33 26.76-65.17 26.77-26.83 65-26.83Q358-840 385-813.17q27 26.84 27 65.17v286q42 26 66 68.45T502-302q0 75.53-53.23 128.76Q395.53-120 320-120Zm.12-59q50.88 0 86.38-35.88Q442-250.75 442-302q0-37.81-18-70.41Q406-405 372-420l-20-9v-319q0-13.6-9.2-22.8-9.2-9.2-22.8-9.2-13.6 0-22.8 9.2-9.2 9.2-9.2 22.8v319l-20 9q-34 15-52 47.59-18 32.6-18 70.41 0 51.25 35.62 87.12Q269.24-179 320.12-179ZM320-302Z"
		/>
	</svg>
);
